import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTracking } from 'react-tracking';
import { useMount } from '@simplywallst/ui-core';
import { Button } from '@simplywallst/ui-core/next';
import { ROUTE_PORTFOLIO_NEW } from '@/constants/routes';
import GuestRegistrationModal from '@/components/GuestRegistrationModal';
import useUser from '@/hooks/useUser';
import { getPath } from '@/router/utils';

const IDLE_TIMEOUT_MS = 3 * 60 * 1000; // 3mins

export const CreateNewPortfolioBanner = () => {
  const { trackEvent } = useTracking();
  const [showPromptModal, setShowPromptModal] = useState(false);
  const [showIdleModal, setShowIdleModal] = useState(false);
  const [hasPromptModalShown, setHasPromptModalShown] = useState(false);
  const { data: user } = useUser();
  const dispatch = useDispatch();

  useMount(() => {
    const timer = setTimeout(() => setShowIdleModal(true), IDLE_TIMEOUT_MS);
    return () => clearTimeout(timer);
  });

  const handleCreatePortfolioClick = () => {
    trackEvent({
      subject: 'banner',
      modifier: 'createNewPortfolio',
      action: 'click',
    });

    if (user.loggedIn) {
      return dispatch({ type: ROUTE_PORTFOLIO_NEW });
    }
    setShowPromptModal(true);
    setHasPromptModalShown(true);
  };

  return (
    <>
      <div className="sticky top-[calc(63px+env(safe-area-inset-top))] z-sticky grid h-x6 w-full place-items-center bg-surface-2">
        <div className="w-full max-w-screen-xl px-x2 text-center text-xs text-solid lg:px-x3">
          <span className="mr-x2">
            Want a portfolio like this?{' '}
            <span className="hidden md:inline">
              Create your own to analyze and improve your investments
            </span>
          </span>
          <Button
            variant="primary"
            size="medium"
            onClick={handleCreatePortfolioClick}
          >
            Create my portfolio
          </Button>
        </div>
      </div>
      {showPromptModal && (
        <GuestRegistrationModal
          canClose
          postVerifyRedirectTo={getPath({
            type: ROUTE_PORTFOLIO_NEW,
            payload: {},
          })}
          onClose={() => {
            trackEvent({
              action: 'close',
              modifier: 'log_in_sign_up',
            });
            setShowPromptModal(false);
          }}
          onRegisterSuccess={() => {
            trackEvent({
              subject: 'DemoPortfolioBanner',
              modifier: 'registration',
              action: 'success',
            });
            setShowPromptModal(false);
            dispatch({ type: ROUTE_PORTFOLIO_NEW });
          }}
          onLoginSuccess={() => {
            trackEvent({
              subject: 'DemoPortfolioBanner',
              modifier: 'login',
              action: 'success',
            });
            setShowPromptModal(false);
            dispatch({ type: ROUTE_PORTFOLIO_NEW });
          }}
        />
      )}
      {!user.loggedIn && !hasPromptModalShown && showIdleModal && (
        <GuestRegistrationModal
          canClose
          postVerifyRedirectTo={getPath({
            type: ROUTE_PORTFOLIO_NEW,
            payload: {},
          })}
          onMount={() => {
            trackEvent({
              modifier: 'idle_guest_registration_modal',
              action: 'displayed',
            });
          }}
          onClose={() => {
            trackEvent({
              modifier: 'idle_guest_registration_modal',
              action: 'close',
            });
            setShowIdleModal(false);
          }}
          onRegisterSuccess={() => {
            trackEvent({
              modifier: 'idle_guest_registration_modal',
              action: 'registration_success',
            });
            setShowIdleModal(false);
          }}
          onLoginSuccess={() => {
            trackEvent({
              modifier: 'idle_guest_registration_modal',
              action: 'login_success',
            });
            setShowIdleModal(false);
          }}
        />
      )}
    </>
  );
};
